import { CamelCasedPropertiesDeep } from 'type-fest';
import { z } from 'zod/v4';
import { createDefinitionSchema } from '../../utils/helpers';

/**
 * Type for the spec-driven `DashboardPanel` variant of the External panel.
 */
export interface ExternalPanelSpec extends z.TypeOf<typeof externalPanelSpecSchema> {}

/**
 * Zod schema for the spec-driven `DashboardPanel` variant of the external panel.
 */
export const externalPanelSpecSchema = z.object({
  url: z.string(),
  content_width: z.number().optional(),
  content_height: z.number().optional(),
});

/**
 * The schema for an External `DashboardPanel` definition.
 */
export interface ExternalPanelDefinition extends z.TypeOf<typeof externalPanelDefinitionSchema> {}
// externalPanelSchema is a schema for an External panel, which essentially implements Definition<ExternalPanelSpec, 'External'>.
export const externalPanelDefinitionSchema = createDefinitionSchema('External', externalPanelSpecSchema);

/**
 * Version of the Zod schema to be used for base types for the props-driven `Viz` variant of the external panel.
 *
 * Currently, it is the same as the spec-driven variant, but it may need to change in the future to
 * do things like flatten a specific property or some other transform (examples can be found in pie chart).
 */
export const externalVizSchema = externalPanelSpecSchema;

/**
 * Base type for the props-driven `Viz` variant of the external panel generated from the Zod schema and
 * converting all snake_case properties to camelCase. This interface should be extended in `viz-framework`
 * to do the following:
 * - Add additional types for `Viz` only use cases.
 * - Extend properties to add more meaningful jsdoc. This is necessary because both `z.Typeof` and
 *   `CamelCasedPropertiesDeep` lose jsdoc.
 */
export interface ExternalPanelPropsBase extends CamelCasedPropertiesDeep<z.TypeOf<typeof externalVizSchema>> {}
